import { createStore } from 'vuex';
import getters from './getters/index';
import actions from './actions/index';
import user from './modules/user';
import home from './modules/home';
import trade from './modules/trade';
import pay from './modules/pay';
import server from './modules/server';

console.log("createStore", createStore)
export default createStore({
  getters,
  actions,
  modules: {
    user,
    home,
    trade,
    pay,
    server,
  },
});
